export const LS_LAST_SELECTED_PROJECT_ID = 'lastSelectedProjectId';
